import { useEffect } from 'react';

import { AnimatedCheckbox } from '@components/checkbox';

import { FilterActionButtons } from '../actions-buttons';
import { useFilterTranslate } from '../filter-utils';
import { FilterListItem } from '../list-item';
import { FilterConfigField } from '../shared-types';
import { CurrentFilterState, CurrentFilterActions } from '../use-current-filter';

type ValueType = 'warning' | 'no-issue' | 'error';

export const IssuesMenu = ({
  config,
  state,
  actions,
}: {
  config: FilterConfigField;
  state: CurrentFilterState;
  actions: CurrentFilterActions;
}) => {
  const { t } = useFilterTranslate();

  useEffect(() => {
    if (state.comparer !== 'contains_multi') {
      actions.selectComparer('contains_multi');
    }
  }, [actions, state.comparer]);

  if (config.type !== 'issues') return null;

  // Get values - either static array or dynamically computed
  const values = typeof config.values === 'function' ? config.values(state) : config.values;

  return (
    <>
      {values.map(({ value, icon }: any) => {
        const isCurrentValue = Array.isArray(state.value)
          ? state.value.some((val) => val === value)
          : state.value === value;

        return (
          <FilterListItem
            key={value}
            selectionIcon={<AnimatedCheckbox checked={isCurrentValue} />}
            icon={icon}
            label={t(value as ValueType)}
            onClick={() => {
              actions.selectValue(value);
            }}
          />
        );
      })}
      <FilterActionButtons
        state={state}
        actions={actions}
        disableApply={!state.value || (Array.isArray(state.value) && state.value.length === 0)}
      />
    </>
  );
};
